import { Drawer, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  ${Drawer.Styled.Container} {
    width: 720px;
  }

  ${Drawer.Styled.Header} {
    padding-left: 8px;
  }
`;

export const ScenarioDrawerWrapper = styled.div`
  padding: 0 20px 20px 20px;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background: var(--border-soft);
  margin: 40px 0;
`;

export const LineBreak = styled.div`
  width: 100%;
  height: 1px;
  margin: 40px 0;
`;

export const Header = styled.div`
  margin-bottom: 40px;
`;

export const Title = styled.h2`
  ${typographyV2.titleBase};
  color: var(--text-default);
`;

export const Subtitle = styled.div`
  ${typographyV2.bodySm}
  color: var(--text-soft);
`;
